<template>
  <div class="card-recommendation">
    <el-card class="search-card">
      <div slot="header" class="clearfix">
        <span>今日好卡列表</span>
        <el-button style="float: right;" type="primary" size="small" icon="el-icon-plus" @click="handleAdd">新增</el-button>
      </div>

      <el-table :data="tableData" border stripe v-loading="tableLoading" height="calc(100vh - 280px)">
        <el-table-column prop="id" label="ID" width="80" align="center"></el-table-column>
        <el-table-column prop="title" label="标题" min-width="200"></el-table-column>
        <el-table-column label="图片" width="140">
          <template slot-scope="scope">
            <el-image
              v-if="scope.row.imageUrl"
              :src="scope.row.imageUrl"
              style="width: 100px; height: 70px;"
              fit="cover"
              :preview-src-list="[scope.row.imageUrl]"
            ></el-image>
            <span v-else style="color: #C0C4CC;">-</span>
          </template>
        </el-table-column>
        <el-table-column prop="sort" label="排序" width="100" align="center"></el-table-column>
        <el-table-column prop="status" label="状态" width="100" align="center">
          <template slot-scope="scope">
            <el-tag :type="scope.row.status === 1 ? 'success' : 'info'" size="small">
              {{ scope.row.status === 1 ? '启用' : '禁用' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间" width="170"></el-table-column>
        <el-table-column label="操作" fixed="right" width="180">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="handleEdit(scope.row)">编辑</el-button>
            <el-button type="text" size="small" @click="handleStatus(scope.row)">
              {{ scope.row.status === 1 ? '禁用' : '启用' }}
            </el-button>
            <el-button type="text" size="small" @click="handleDelete(scope.row)" style="color: #F56C6C;">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handlePageChange"
        :current-page="pagination.pageNum"
        :page-sizes="[10, 20, 50]"
        :page-size="pagination.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pagination.total"
        style="margin-top: 20px; text-align: right;">
      </el-pagination>
    </el-card>

    <!-- 新增/编辑对话框 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="600px" @close="handleDialogClose">
      <el-form :model="form" :rules="rules" ref="form" label-width="90px">
        <el-form-item label="标题" prop="title">
          <el-input v-model="form.title" placeholder="请输入标题" maxlength="100" show-word-limit></el-input>
        </el-form-item>

        <el-form-item label="图片" prop="imageUrl">
          <div class="upload-wrap">
            <el-upload
              class="activity-uploader"
              :show-file-list="false"
              :http-request="handleUploadRequest"
            >
              <img v-if="form.imageUrl" :src="form.imageUrl" class="uploaded-img" />
              <i v-else class="el-icon-plus uploader-icon"></i>
            </el-upload>
            <div class="upload-tip">
              <span v-if="uploading" class="uploading-text"><i class="el-icon-loading"></i> 上传中...</span>
              <span v-else>支持 JPG、PNG，建议尺寸 750×500</span>
            </div>
          </div>
        </el-form-item>

        <el-form-item label="排序" prop="sort">
          <el-input-number v-model="form.sort" :min="0" :max="9999" :step="1"></el-input-number>
          <span class="form-tip" style="margin-left:12px;">数字越小越靠前</span>
        </el-form-item>

        <el-form-item label="状态" prop="status">
          <el-radio-group v-model="form.status">
            <el-radio :label="1">启用</el-radio>
            <el-radio :label="0">禁用</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleSubmit" :loading="submitLoading">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 图片预览 -->
    <el-dialog title="图片预览" :visible.sync="previewVisible" width="60%" append-to-body>
      <img :src="previewUrl" style="max-width: 100%; display: block; margin: 0 auto;" />
    </el-dialog>
  </div>
</template>

<script>
import { getCardList, addCard, updateCard, deleteCard, updateCardStatus, uploadCardImage } from '@/api'

export default {
  name: 'CardRecommendation',
  data() {
    return {
      tableData: [],
      tableLoading: false,
      pagination: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      dialogVisible: false,
      dialogTitle: '',
      previewVisible: false,
      previewUrl: '',
      submitLoading: false,
      uploading: false,
      form: {
        id: null,
        title: '',
        imageUrl: '',
        sort: 0,
        status: 1
      },
      rules: {
        title: [{ required: true, message: '请输入标题', trigger: 'blur' }],
        imageUrl: [{ required: true, message: '请上传图片', trigger: 'change' }]
      }
    }
  },
  created() {
    this.loadData()
  },
  methods: {
    async loadData() {
      this.tableLoading = true
      try {
        const res = await getCardList({
          pageNum: this.pagination.pageNum,
          pageSize: this.pagination.pageSize
        })
        this.tableData = res.data?.records || res.data || []
        this.pagination.total = res.data?.total || 0
      } catch (e) {
        this.$message.error('加载数据失败')
      } finally {
        this.tableLoading = false
      }
    },

    handlePageChange(page) {
      this.pagination.pageNum = page
      this.loadData()
    },

    handleSizeChange(size) {
      this.pagination.pageSize = size
      this.pagination.pageNum = 1
      this.loadData()
    },

    handleAdd() {
      this.dialogTitle = '新增今日好卡'
      this.resetForm()
      this.dialogVisible = true
    },

    handleEdit(row) {
      this.dialogTitle = '编辑今日好卡'
      this.form = {
        id: row.id,
        title: row.title,
        imageUrl: row.imageUrl,
        sort: row.sort,
        status: row.status
      }
      this.dialogVisible = true
    },

    handleDialogClose() {
      this.$refs.form && this.$refs.form.resetFields()
      this.resetForm()
    },

    resetForm() {
      this.form = { id: null, title: '', imageUrl: '', sort: 0, status: 1 }
    },

    async handleUploadRequest({ file }) {
      const isImage = file.type.startsWith('image/')
      const isLt10M = file.size / 1024 / 1024 < 10
      if (!isImage) {
        this.$message.error('只能上传图片文件!')
        return false
      }
      if (!isLt10M) {
        this.$message.error('图片大小不能超过 10MB!')
        return false
      }
      this.uploading = true
      try {
        const res = await uploadCardImage(file)
        if (res.code === 200) {
          this.form.imageUrl = res.data.url
          this.$message.success('上传成功')
        } else {
          this.$message.error(res.message || '上传失败')
        }
      } catch (e) {
        this.$message.error('上传失败，请重试')
      } finally {
        this.uploading = false
      }
    },

    handleSubmit() {
      this.$refs.form.validate(async (valid) => {
        if (!valid) return
        this.submitLoading = true
        try {
          if (this.form.id) {
            await updateCard(this.form.id, this.form)
            this.$message.success('更新成功')
          } else {
            await addCard(this.form)
            this.$message.success('新增成功')
          }
          this.dialogVisible = false
          this.loadData()
        } catch (e) {
          // 错误已在拦截器处理
        } finally {
          this.submitLoading = false
        }
      })
    },

    handleStatus(row) {
      const action = row.status === 1 ? '禁用' : '启用'
      this.$confirm(`确定要${action}「${row.title}」吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          await updateCardStatus(row.id, row.status === 1 ? 0 : 1)
          this.$message.success(`${action}成功`)
          this.loadData()
        } catch (e) {}
      }).catch(() => {})
    },

    handleDelete(row) {
      this.$confirm(`确定要删除「${row.title}」吗？`, '删除确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          await deleteCard(row.id)
          this.$message.success('删除成功')
          this.loadData()
        } catch (e) {}
      }).catch(() => {})
    }
  }
}
</script>

<style scoped lang="scss">
.card-recommendation {
  padding: 20px;
}

.upload-wrap {
  display: flex;
  align-items: center;
  gap: 16px;
}

.activity-uploader {
  ::v-deep .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    transition: border-color 0.2s;

    &:hover {
      border-color: #FF8C00;
    }
  }

  .uploaded-img {
    width: 148px;
    height: 148px;
    object-fit: cover;
    display: block;
  }

  .uploader-icon {
    width: 148px;
    height: 148px;
    line-height: 148px;
    text-align: center;
    font-size: 28px;
    color: #8c939d;
  }
}

.upload-tip {
  color: #909399;
  font-size: 12px;
  line-height: 1.4;

  .uploading-text {
    color: #FF8C00;
  }
}

.form-tip {
  color: #909399;
  font-size: 12px;
}
</style>
